import React from 'react';
import usePrepTeamRequestContext from 'contexts/kitchen/prep-team-request.context/context';
import useDashboardContext from 'contexts/dashboard.context';
import BatchItemsForm from 'components/base/batch-items-form';

type Props = {
  selectedItemId: string;
  onSuccess: () => void;
  onCancel: () => void;
};

const SendItemsForm: React.FC<Props> = ({ selectedItemId, onSuccess, onCancel }) => {
  const { itemRequestToEdit } = usePrepTeamRequestContext();
  const { activeStore } = useDashboardContext();

  return (
    <BatchItemsForm
      requestId={itemRequestToEdit.id}
      selectedItemId={selectedItemId}
      storeId={activeStore?.id || ''}
      apiEndpoint='prep-kitchen-request'
      successMessage='Items sent successfully'
      onSuccess={onSuccess}
      onCancel={onCancel}
    />
  );
};

export default SendItemsForm;
